import React, { useState } from 'react';
import { rechargeAgent } from '../api/mongoServices';

const getBonus = (amount) => {
  if (amount >= 900) return 0.3;
  if (amount >= 700) return 0.25;
  if (amount >= 500) return 0.2;
  if (amount >= 300) return 0.15;
  if (amount >= 100) return 0.1;
  return 0;
};

const RechargeModal = ({ agent, onClose }) => {
  const [amount, setAmount] = useState('');

  const bonusPercent = getBonus(parseInt(amount));
  const totalWithBonus = amount ? parseInt(amount) + parseInt(amount * bonusPercent) : 0;

  const handleRecharge = async () => {
    await rechargeAgent(agent.number, parseInt(amount), totalWithBonus);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white rounded-lg p-6 w-96">
        <h3 className="text-xl font-bold mb-2">Recharge for {agent.name}</h3>
        <input
          type="number"
          value={amount}
          placeholder="Enter points"
          onChange={(e) => setAmount(e.target.value)}
          className="border px-3 py-2 w-full mb-3"
        />
        {amount && (
          <div>
            <p className="text-sm text-green-600">
              Bonus: {bonusPercent * 100}%  + special bonus 0% → Total Points Added: <strong>{totalWithBonus}</strong>
            </p>
          </div>
        )}
        <div className="flex justify-end gap-2 mt-4">
          <button className="px-4 py-2 bg-gray-400 text-white rounded" onClick={onClose}>Cancel</button>
          <button className="px-4 py-2 bg-blue-600 text-white rounded" onClick={handleRecharge}>Recharge</button>
        </div>
      </div>
    </div>
  );
};

export default RechargeModal;
